import styled, { css } from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import { typography } from '@clds/typography';
import { media } from '@clds/style-utils';
import { MenuRoot } from './Menu/Menu.styles';
import { theme as t } from './CustomTransformationCardTheme';

const phone = media.phone();
const tabletAndAboveQuery = media.tablet({ minOnly: true });

export const CardWrapper = styled.div`
  min-height: ${t.minHeight};
  padding-bottom: ${globalTheme.spacing.xs};
`;

export const Card = styled.div<{ isSkeleton?: boolean }>`
  display: flex;
  flex-shrink: 0;
  min-height: ${t.minHeight};
  width: 100%;
  border-radius: ${t.radius};
  background: ${t.background};
  color: ${t.color};
  transition: box-shadow 0.2s ease-out;
  padding-right: ${globalTheme.spacing.sm};

  &:hover {
    box-shadow: ${globalTheme.shadow.sm};
  }

  button > svg path {
    fill: ${t.color};
  }

  @media (hover: hover) {
    // Graceful degradation by reverting condition
    &:not(:hover):not(:focus-within) ${MenuRoot} {
      visibility: hidden;

      // Hide svg as well, since svg can be visible even if parent is hidden
      svg {
        visibility: hidden;
      }
    }
  }

  @media ${tabletAndAboveQuery} {
    align-items: center;
  }

  @media ${phone} {
    flex-direction: column;
    ${({ isSkeleton }) =>
      isSkeleton &&
      css`
        overflow: hidden;
      `};
    min-height: ${({ isSkeleton }) => (isSkeleton ? 'auto' : t.onPhone.minHeight)};
  }
`;

export const CardContent = styled.div`
  padding: ${globalTheme.spacing.lg};
  word-break: break-word;
  display: flex;
  flex-flow: column;
  min-width: 0;

  > :first-child {
    margin-bottom: ${t.verticalSpacing};
  }
`;

export const Info = styled.div`
  ${typography.xxs.lowContrast};
  margin-top: ${t.verticalSpacing};
`;
